import GeneralSockets from './GeneralSockets';

export default GeneralSockets;
